"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var reportIfFileIsValid = function (file, uploadSizeLimit, errorMessages) {
    var isFileCorrectType = (file.type === "application/pdf"
        || file.type === "image/jpeg"
        || file.type === "image/png"
        || file.type === "text/csv"
        || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        || file.type === "application/vnd.oasis.opendocument.spreadsheet");
    var isFileCorrectSize = (file.size <= uploadSizeLimit);
    if (!isFileCorrectType) {
        antd_1.notification.error({
            message: errorMessages.uploadFailed,
            description: errorMessages.uploadErrorWrongType
        });
    }
    if (!isFileCorrectSize) {
        antd_1.notification.error({
            message: errorMessages.uploadFailed,
            description: errorMessages.uploadErrorToLarge
        });
    }
    return isFileCorrectType && isFileCorrectSize;
};
exports.reportIfFileIsValid = reportIfFileIsValid;
